export { WhatsappFloatingButton } from "./WhatsappFloatingButton";
export type {
  WhatsappFloatingButtonProps,
  FloatingButtonPosition,
} from "./WhatsappFloatingButton";
